import { Settings } from '../types';
import callApi from '../utils/apiCaller';
import localeToExpertise from './localeToExpertise';

const overrideSdkLanguageSettings = async (language: string) =>
    await callApi(
        async ({ appendSettings }) =>
            await appendSettings((settings: Settings) => {
                if (!settings.expertiseByTag) {
                    settings.expertiseByTag = {};
                }

                const expertise = localeToExpertise(language);
                settings.expertiseByTag.language = [expertise];

                return {
                    ...settings,
                    language,
                };
            })
    );

export default overrideSdkLanguageSettings;
